import { defineMessages } from 'react-intl';

export default defineMessages({
  closeModal: {
    id: 'BundleGiftAOV.closeModal',
    description: 'Close modal button aria-label',
    defaultMessage: 'Close modal',
  },
  totalDiscountPrice: {
    id: 'BundleGiftAOV.totalDiscountPrice',
    defaultMessage: '{price} value',
  },
  freeGift: {
    id: 'BundleGiftAOV.freeGift',
    defaultMessage: 'Free Gift',
  },
  sheet: {
    id: 'BundleGiftAOV.sheet',
    defaultMessage: 'Sheet',
  },
  bundleDetails: {
    id: 'BundleGiftAOV.bundleDetails',
    defaultMessage: 'Bundle details',
  },
  addSelectedToCart: {
    id: 'BundleGiftAOV.addSelectedToCart',
    description: 'Add items selected to cart',
    defaultMessage: 'Add Selected to Cart',
  },
  errorAddingItems: {
    id: 'BundleGiftAOV.errorAddingItems',
    defaultMessage: 'Something went wrong, please try again.',
  },
  viewShoppingCart: {
    id: 'BundleGiftAOV.viewShoppingCart',
    defaultMessage: 'No Thanks. Continue to Cart',
  },
  selectBundle: {
    id: 'BundleGiftAOV.selectBundle',
    defaultMessage: 'Selected Bundle',
  },
});
